export default {
  data() {
    return {
      twCountryCode: 7043,
    }
  },
  computed: {
    countryCode() {
      return parseInt(this.$store.state.common.countryCode)
    },
  },
}
